export function scrollToContactForm(nested = false): void {
  const targets: HTMLElement[] = Array.from(document.querySelectorAll('.anchor-contactForm'));
  const targetDesctop: HTMLElement = nested ? targets[2] : targets[0];
  const targetMobile: HTMLElement = nested ? targets[3] : targets[1];

  (targetDesctop as HTMLElement).scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  (targetMobile as HTMLElement).scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
}
